import { AchFileErrorModelDto, AchFileValidationErrorDto } from '@treasury/api/channel';
import { DomainEntity } from '../shared';

export class AchFileValidationError extends DomainEntity<AchFileValidationErrorDto> {
    public createDefault(): this {
        return new AchFileValidationError({
            batchName: '',
            lineNumber: 0,
            message: '',
            action: '',
            record: '',
        }) as this;
    }

    public get batchName() {
        return this.dto.batchName;
    }

    public get lineNumber() {
        return this.dto.lineNumber;
    }

    public get message() {
        return this.dto.message;
    }

    public get action() {
        return this.dto.action;
    }

    public get record() {
        return this.dto.record;
    }
}

export class AchFileError extends DomainEntity<AchFileErrorModelDto> {
    public createDefault(): this {
        return new AchFileError({
            validationErrors: [],
            success: false,
            errorSummary: {
                id: 0,
                updatedDate: '',
                type: 0, // ErrorTypeModelDto.Error
                summaryMessage: '',
                summaryMessageList: [],
                details: [],
            },
        }) as this;
    }

    public get validationErrors() {
        return this.dto.validationErrors?.map(error => new AchFileValidationError(error)) ?? [];
    }

    public get success() {
        return this.dto.success;
    }

    public get errorSummary() {
        return this.dto.errorSummary;
    }
}
